/**
 * SP-3 C3 (2026-07-12) — the Today lifecycle hero (in_season-undrafted +
 * season-complete), restyled to the ratified empty-state anatomy
 * (first-plan/README.md §empty-states + frame 1i, card 2). Presentational only:
 * the copy + hrefs come from `lifecycleHeroProps` (todayHeroAdapter.ts). Plain
 * `<a>` anchors with full `/v2` paths — the same idiom the prior TodayHero
 * lifecycle CTA used (the readiness/reward strips it used to carry are dropped;
 * the empty-state family is a single self-contained card, "max one per screen").
 */

import type { LifecycleHeroProps } from '../../lib/todayHeroAdapter';
import styles from './plan.module.css';

export function LifecycleEmptyHero({ hero }: { hero: LifecycleHeroProps }) {
  return (
    <section className={styles.esCard} aria-label={hero.title}>
      <div className={styles.esGlyph} aria-hidden="true">
        <span className={styles.esTile}>{hero.glyphNumeral ?? ''}</span>
      </div>
      {hero.kicker ? <div className={styles.esKicker}>{hero.kicker}</div> : null}
      <h2 className={styles.esTitle}>{hero.title}</h2>
      <p className={styles.esBody}>{hero.body}</p>
      <div className={styles.esActions}>
        <a className={styles.esPrimary} href={hero.ctaHref}>
          {hero.ctaLabel}
        </a>
        {hero.secondaryLabel && hero.secondaryHref ? (
          <a className={styles.esSecondary} href={hero.secondaryHref}>
            {hero.secondaryLabel}
          </a>
        ) : null}
      </div>
    </section>
  );
}
